import { isEmpty } from '@sgme/fp';
import type { ICellRendererParams } from 'ag-grid-community';
import { CurrencyFlagIcon } from 'components/shared/WithCountryFlag';
import type { FC, PropsWithChildren } from 'react';

export const CurrencyCellRenderer: FC<PropsWithChildren<ICellRendererParams<unknown, string>>> = ({ value }) => {
  if (isEmpty(value)) {
    return null;
  }
  return (
    <>
      <CurrencyFlagIcon currency={value} size="sm" className="me-2" />
      {value}
    </>
  );
};
